import React, { useEffect, useState } from "react";
import "../Gallery/GallarySlider.css"; // Ensure this path is correct
import { galleryimage } from "../../config/services";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import { images } from "../../config/images";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";
import { useLocation } from "react-router-dom";

const GallerySlider = ({ headerAPIData }) => {
  const [galleryAPIData, setGalleryAPIData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setIsLoading] = useState(false);
  const location = useLocation();
  const { name, galleryId } = location.state || {};

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    { label: "Gallery", url: "/gallery" },
    { label: name },
  ];

  // Fetch gallery data
  useEffect(() => {
    const fetchGallery = async () => {
      if (!galleryId) return;
      const params = {
        id: galleryId,
      };

      try {
        setIsLoading(true);
        const resp = await galleryimage(params);
        if (resp.data.code === 200 || resp.data.code === 201) {
          setIsLoading(false);
          setGalleryAPIData(resp.data.responseBody);
        }
      } catch (error) {
        setIsLoading(false);
        setGalleryAPIData([]);
      }
    };
    fetchGallery();
  }, []);

  // Handle next/prev slide
  const changeSlide = (step) => {
    const validSlides = Object.values(galleryAPIData).filter(
      (slide) => typeof slide === "object" && slide.image
    );
    let newIndex = currentIndex + step;
    if (newIndex < 0) newIndex = validSlides.length - 1;
    if (newIndex >= validSlides.length) newIndex = 0;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const validSlides = Object.values(galleryAPIData).filter(
      (slide) => typeof slide === "object" && slide.image
    );
    if (validSlides.length > 1) {
      const interval = setInterval(() => {
        changeSlide(1);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [currentIndex, galleryAPIData]);

  return (galleryAPIData && headerAPIData).length === 0 ? (
    <FullpageLoader />
  ) : (
    <div>
      <div className="about-us-container">
        <div className="molecule left">
          <img
            src={images.leftSpirrel}
            alt="Left Molecule"
            className="left-spinner"
          />
        </div>
        <div className="about-text">
          <h1>Gallery</h1>
          <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
        </div>
        <div className="molecule right">
          <img
            src={images.rightSpirrel}
            alt="Right Molecule"
            className="right-spinner"
          />
        </div>
      </div>
      <h4 className="gallery-detail-title mt-5">{name}</h4>
      <div className="gallery-slider-container mt-5 mb-5">
        {!loading ? (
          Object.values(galleryAPIData).filter(
            (slide) => typeof slide === "object" && slide.image
          ).length > 0 ? (
            <div className="gallery-slider">
              {Object.values(galleryAPIData)
                .filter((slide) => typeof slide === "object" && slide.image)
                .map((slide, index) => (
                  <div
                    key={index}
                    className={`gallery-slider-slide ${
                      currentIndex === index ? "active" : ""
                    }`}
                  >
                    <img
                      className="gallery-slider-image"
                      src={slide.image}
                      alt={`Slide ${index + 1}`}
                    />
                  </div>
                ))}
              <span
                className="gallery-slider-controls gallery-slider-left-arrow"
                onClick={() => changeSlide(-1)}
              >
                <i className="fa fa-arrow-left" aria-hidden="true"></i>
              </span>
              <span
                className="gallery-slider-controls gallery-slider-right-arrow"
                onClick={() => changeSlide(1)}
              >
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </span>
            </div>
          ) : (
            <div className="gallery-slider-empty-state" role="status" aria-live="polite">
              <div className="gallery-slider-empty-state-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
              </div>
              <h3>Record not found</h3>
              <p>No images are available for this gallery yet. Please check back later or browse other gallery items.</p>
            </div>
          )
        ) : (
          <div className="no-records-found gallery-slider">
            <div className="shimmer" style={{ height: "650px" }}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GallerySlider;
